import { useMemo } from "react";
import { FormattedIdentityProviderConfiguration } from "@idw-types/data/identity-providers";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { sortStrings } from "@utils/string-util";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";

type IdentityProviderSelectFormGroupProps = BaseSelectFormGroupProps & {
    identityProviders: Array<FormattedIdentityProviderConfiguration>
};

export const IdentityProviderSelectFormGroup = (props: IdentityProviderSelectFormGroupProps) => {
    const { identityProviders, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const identityProviderOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(identityProviders).sort((a, b) => sortStrings(a.label, b.label));
    }, [identityProviders]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-identity-provider-select`}
            label={resources.common.inputs.identityProvider.label}
            ariaLabel={resources.common.inputs.identityProvider.label}
            automationId={`${idPrefix}-identity-provider-select`}
            onChange={onChange}
            options={identityProviderOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};